import { i18n } from "@next-core/i18n";

export enum K {
  DESCRIPTION = "DESCRIPTION",
  SPACE_GUIDE_SECTION_TITLE = "SPACE_GUIDE_SECTION_TITLE",
  SPACE_GUIDE_CARD_1_TITLE = "SPACE_GUIDE_CARD_1_TITLE",
  SPACE_GUIDE_CARD_2_TITLE = "SPACE_GUIDE_CARD_2_TITLE",
  SPACE_GUIDE_CARD_3_TITLE = "SPACE_GUIDE_CARD_3_TITLE",
  BUSINESS_OBJECTS = "BUSINESS_OBJECTS",
  BUSINESS_FLOWS = "BUSINESS_FLOWS",
  NO_BUSINESS_OBJECTS_FLOWS = "NO_BUSINESS_OBJECTS_FLOWS",
  GUIDE_AI_TO_GENERATE_CONFIG = "GUIDE_AI_TO_GENERATE_CONFIG",
  NO_CONFIGURATION_DATA = "NO_CONFIGURATION_DATA",
  FIELD_DEFINITIONS = "FIELD_DEFINITIONS",
  LIFECYCLE_STATUS = "LIFECYCLE_STATUS",
  PREREQUISITES = "PREREQUISITES",
  PREREQUISITES_SUBTITLE = "PREREQUISITES_SUBTITLE",
  ACTIVITY_DESCRIPTION = "ACTIVITY_DESCRIPTION",
  NO_DESCRIPTION = "NO_DESCRIPTION",
  RESPONSIBLE_AI_EMPLOYEE = "RESPONSIBLE_AI_EMPLOYEE",
  SELECT_AI_EMPLOYEE_PLACEHOLDER = "SELECT_AI_EMPLOYEE_PLACEHOLDER",
  HITL_RULES = "HITL_RULES",
  HITL_INTERVENTION_USER = "HITL_INTERVENTION_USER",
  SELECT_HITL_USER_PLACEHOLDER = "SELECT_HITL_USER_PLACEHOLDER",
  SPACE_CONFIGURATION = "SPACE_CONFIGURATION",
  SAVE_CONFIGURATION = "SAVE_CONFIGURATION",
  CANCEL = "CANCEL",
  PLEASE_ENTER = "PLEASE_ENTER",
  CONFIG_ASSISTANT_PLACEHOLDER = "CONFIG_ASSISTANT_PLACEHOLDER",
  ADD_INSTANCE_ASSISTANT_PLACEHOLDER = "ADD_INSTANCE_ASSISTANT_PLACEHOLDER",
  CONFIG_ASSISTANT_WELCOME = "CONFIG_ASSISTANT_WELCOME",
  KNOWLEDGE = "KNOWLEDGE",
  NO_KNOWLEDGE = "NO_KNOWLEDGE",
  MINUTES_AGO = "MINUTES_AGO",
  HOURS_AGO = "HOURS_AGO",
  DAYS_AGO = "DAYS_AGO",
  NEW_SESSION = "NEW_SESSION",
  HISTORY_SESSIONS = "HISTORY_SESSIONS",
  CLOSE_TAB = "CLOSE_TAB",
  FLOW_SIDEBAR_TITLE = "FLOW_SIDEBAR_TITLE",
  FLOW_SIDEBAR_SUBTITLE = "FLOW_SIDEBAR_SUBTITLE",
  NO_HISTORY = "NO_HISTORY",
  LOADING = "LOADING",
  LOAD_MORE = "LOAD_MORE",
  NO_BUSINESS_OBJECTS = "NO_BUSINESS_OBJECTS",
  LOAD_FAILED = "LOAD_FAILED",
  CLICK_TO_RETRY = "CLICK_TO_RETRY",
  NO_INSTANCES = "NO_INSTANCES",
  ADD_KNOWLEDGE = "ADD_KNOWLEDGE",
  ADD_INSTANCE_MODAL_TITLE = "ADD_INSTANCE_MODAL_TITLE",
  ADD_INSTANCE_ASSISTANT_WELCOME = "ADD_INSTANCE_ASSISTANT_WELCOME",
  IDENTIFIED_INSTANCES = "IDENTIFIED_INSTANCES",
  NO_INSTANCES_IDENTIFIED = "NO_INSTANCES_IDENTIFIED",
  NO_INSTANCES_IDENTIFIED_DESCRIPTION = "NO_INSTANCES_IDENTIFIED_DESCRIPTION",
  INSTANCE_DETAIL = "INSTANCE_DETAIL",
  NO_DETAIL = "NO_DETAIL",
  CONFIRM_CREATE = "CONFIRM_CREATE",
  EDIT_INSTANCE = "EDIT_INSTANCE",
  DELETE_INSTANCE = "DELETE_INSTANCE",
  NO_DETAIL_HINT = "NO_DETAIL_HINT",
  ACTIVITY_RECORD = "ACTIVITY_RECORD",
  NO_ACTIVITY_RECORD = "NO_ACTIVITY_RECORD",
  NO_ACTIVITY_RECORD_DESCRIPTION = "NO_ACTIVITY_RECORD_DESCRIPTION",
  INSTANCE_DETAIL_CHAT_PLACEHOLDER = "INSTANCE_DETAIL_CHAT_PLACEHOLDER",
  NO_SERVICE_FLOWS = "NO_SERVICE_FLOWS",
  INITIATING_SERVICE_FLOW = "INITIATING_SERVICE_FLOW",
  ADD_COMMENT_PLACEHOLDER = "ADD_COMMENT_PLACEHOLDER",
  CREATED_INSTANCE = "CREATED_INSTANCE",
  EDITED_INSTANCE = "EDITED_INSTANCE",
  COMMENTED = "COMMENTED",
  STARTED_CONVERSATION = "STARTED_CONVERSATION",
  CHANGED_STATUS_TO = "CHANGED_STATUS_TO",
  CONVERSATION = "CONVERSATION",
  STATUS_CHANGED = "STATUS_CHANGED",
  NOT_SET = "NOT_SET",
}

const en: Locale = {
  DESCRIPTION: "Description",
  SPACE_GUIDE_SECTION_TITLE: "I can help you with:",
  SPACE_GUIDE_CARD_1_TITLE: "Manage Business Cases",
  SPACE_GUIDE_CARD_2_TITLE: "Initiate Business Flow",
  SPACE_GUIDE_CARD_3_TITLE: "Manage Space Knowledge",
  BUSINESS_OBJECTS: "Business Objects",
  BUSINESS_FLOWS: "Business Flows",
  NO_BUSINESS_OBJECTS_FLOWS: "No Business Objects/Flows",
  GUIDE_AI_TO_GENERATE_CONFIG:
    "Please guide AI to generate configuration through the left conversation",
  NO_CONFIGURATION_DATA: "No Configuration Data",
  FIELD_DEFINITIONS: "Field Definitions",
  LIFECYCLE_STATUS: "Lifecycle Status",
  PREREQUISITES: "Prerequisites",
  PREREQUISITES_SUBTITLE: "The following conditions must be met:",
  ACTIVITY_DESCRIPTION: "Activity Description",
  NO_DESCRIPTION: "No Description",
  RESPONSIBLE_AI_EMPLOYEE: "Responsible AI Employee",
  SELECT_AI_EMPLOYEE_PLACEHOLDER: "Please select AI employee",
  HITL_RULES: "HITL Rules",
  HITL_INTERVENTION_USER: "HITL Intervention User",
  SELECT_HITL_USER_PLACEHOLDER: "Please select HITL intervention user",
  SPACE_CONFIGURATION: "Space Configuration",
  SAVE_CONFIGURATION: "Save Configuration",
  CANCEL: "Cancel",
  PLEASE_ENTER: "Please enter",
  CONFIG_ASSISTANT_PLACEHOLDER: "Enter command to adjust configuration...",
  CONFIG_ASSISTANT_WELCOME:
    "Hello! I am the space configuration assistant. You can describe your business process, and I will automatically generate related business objects and flows for you. You can also explicitly tell me which business object or flow to modify.",
  KNOWLEDGE: "Knowledge",
  NO_KNOWLEDGE: "No Knowledge",
  MINUTES_AGO: " minutes ago",
  HOURS_AGO: " hours ago",
  DAYS_AGO: " days ago",
  NEW_SESSION: "New Session",
  HISTORY_SESSIONS: "History Sessions",
  CLOSE_TAB: "Close Tab",
  FLOW_SIDEBAR_TITLE: "Business Flows",
  FLOW_SIDEBAR_SUBTITLE: "Click to start business flow",
  NO_HISTORY: "No History",
  LOADING: "Loading...",
  LOAD_MORE: "Load More",
  NO_BUSINESS_OBJECTS: "No Business Objects",
  LOAD_FAILED: "Load Failed",
  CLICK_TO_RETRY: "Click to Retry",
  NO_INSTANCES: "No Instances",
  ADD_KNOWLEDGE: "Add Knowledge",
  ADD_INSTANCE_MODAL_TITLE: "Smart Create {{objectName}}",
  ADD_INSTANCE_ASSISTANT_WELCOME:
    "Hello! I am your instance creation assistant. You can directly provide me with the relevant information or upload files (such as PDF or Excel), and I will automatically parse and generate the instance for you.",
  IDENTIFIED_INSTANCES: "Identified Instances",
  NO_INSTANCES_IDENTIFIED: "No Instances",
  NO_INSTANCES_IDENTIFIED_DESCRIPTION:
    "You can create instances in the left conversation",
  INSTANCE_DETAIL: "Instance Detail",
  NO_DETAIL: "No Detail",
  CONFIRM_CREATE: "Confirm Create",
  EDIT_INSTANCE: "Edit",
  DELETE_INSTANCE: "Delete",
  NO_DETAIL_HINT: "You can select an instance on the left to view details",
  ADD_INSTANCE_ASSISTANT_PLACEHOLDER: "Enter information to create instance...",
  ACTIVITY_RECORD: "Activity Record",
  NO_ACTIVITY_RECORD: "No Activity Record",
  NO_ACTIVITY_RECORD_DESCRIPTION:
    "Activity records will appear here after interactions",
  INSTANCE_DETAIL_CHAT_PLACEHOLDER:
    "Chat about this instance, ask questions or make updates...",
  NO_SERVICE_FLOWS: "No Service Flows",
  INITIATING_SERVICE_FLOW: "Starting serviceflow: {{ name }}",
  ADD_COMMENT_PLACEHOLDER: "Add comment...",
  CREATED_INSTANCE: "created instance",
  EDITED_INSTANCE: "edited instance",
  COMMENTED: "commented",
  STARTED_CONVERSATION: "started conversation",
  CHANGED_STATUS_TO: "changed status to ",
  CONVERSATION: "Conversation",
  STATUS_CHANGED: "Status Changed",
  NOT_SET: "Not Set",
};

const zh: Locale = {
  DESCRIPTION: "描述",
  SPACE_GUIDE_SECTION_TITLE: "我可以协助您完成:",
  SPACE_GUIDE_CARD_1_TITLE: "管理业务案例",
  SPACE_GUIDE_CARD_2_TITLE: "发起业务流",
  SPACE_GUIDE_CARD_3_TITLE: "管理空间知识",
  BUSINESS_OBJECTS: "业务对象",
  BUSINESS_FLOWS: "业务流",
  NO_BUSINESS_OBJECTS_FLOWS: "暂无业务对象/业务流",
  GUIDE_AI_TO_GENERATE_CONFIG: "请通过左侧对话引导 AI 生成配置",
  NO_CONFIGURATION_DATA: "暂无配置数据",
  FIELD_DEFINITIONS: "字段定义",
  LIFECYCLE_STATUS: "生命周期状态",
  PREREQUISITES: "先决条件",
  PREREQUISITES_SUBTITLE: "需要满足以下条件：",
  ACTIVITY_DESCRIPTION: "活动描述",
  NO_DESCRIPTION: "暂无描述",
  RESPONSIBLE_AI_EMPLOYEE: "负责数字人",
  SELECT_AI_EMPLOYEE_PLACEHOLDER: "请选择负责数字人",
  HITL_RULES: "HITL规则",
  HITL_INTERVENTION_USER: "HITL介入用户",
  SELECT_HITL_USER_PLACEHOLDER: "请选择HITL介入用户",
  SPACE_CONFIGURATION: "协作空间配置",
  SAVE_CONFIGURATION: "保存配置",
  CANCEL: "取消",
  PLEASE_ENTER: "请输入",
  CONFIG_ASSISTANT_PLACEHOLDER: "输入指令调整配置...",
  ADD_INSTANCE_ASSISTANT_PLACEHOLDER: "输入信息创建实例...",
  CONFIG_ASSISTANT_WELCOME:
    "您好！我是协作空间配置助手。您可以告诉我描述你的业务流程，我会为你自动生成相关的业务对象和业务流，你也可以明确让我修改哪个业务对象或业务流。",
  KNOWLEDGE: "知识",
  NO_KNOWLEDGE: "暂无知识",
  MINUTES_AGO: "分钟前",
  HOURS_AGO: "小时前",
  DAYS_AGO: "天前",
  NEW_SESSION: "新协作会话",
  HISTORY_SESSIONS: "历史会话列表",
  CLOSE_TAB: "关闭标签",
  FLOW_SIDEBAR_TITLE: "业务流",
  FLOW_SIDEBAR_SUBTITLE: "点击以启动业务流",
  NO_HISTORY: "暂无历史记录",
  LOADING: "加载中...",
  LOAD_MORE: "加载更多",
  NO_BUSINESS_OBJECTS: "暂无业务对象",
  LOAD_FAILED: "加载失败",
  CLICK_TO_RETRY: "点击重试",
  NO_INSTANCES: "暂无数据",
  ADD_KNOWLEDGE: "添加知识",
  ADD_INSTANCE_MODAL_TITLE: "智能创建{{objectName}}",
  ADD_INSTANCE_ASSISTANT_WELCOME:
    "您好！我是您的实例创建助手。您可以直接告诉我相关信息，或者上传文件（如PDF、Excel），我将自动为您解析并生成实例。",
  IDENTIFIED_INSTANCES: "已识别实例",
  NO_INSTANCES_IDENTIFIED: "暂无实例",
  NO_INSTANCES_IDENTIFIED_DESCRIPTION: "你可在左侧对话创建",
  INSTANCE_DETAIL: "详情预览",
  NO_DETAIL: "暂无详情",
  CONFIRM_CREATE: "确认创建",
  EDIT_INSTANCE: "编辑",
  DELETE_INSTANCE: "删除",
  NO_DETAIL_HINT: "你可在左侧选择实例查看详情",
  ACTIVITY_RECORD: "活动记录",
  NO_ACTIVITY_RECORD: "暂无活动记录",
  NO_ACTIVITY_RECORD_DESCRIPTION: "交互后的活动记录将显示在这里",
  INSTANCE_DETAIL_CHAT_PLACEHOLDER: "与此实例对话，提问或更新...",
  NO_SERVICE_FLOWS: "暂无业务流",
  INITIATING_SERVICE_FLOW: "发起业务流：{{ name }}",
  ADD_COMMENT_PLACEHOLDER: "添加评论...",
  CREATED_INSTANCE: "创建了实例",
  EDITED_INSTANCE: "编辑实例",
  COMMENTED: "评论",
  STARTED_CONVERSATION: "发起会话",
  CHANGED_STATUS_TO: "将状态改为",
  CONVERSATION: "会话",
  STATUS_CHANGED: "状态变更",
  NOT_SET: "未设置",
};

export const NS = "bricks/ai-portal/space-workbench";

export const locales = { en, zh };

export const t = i18n.getFixedT(null, NS);

type Locale = { [k in K]: string } & {
  [k in K as `${k}_plural`]?: string;
};
